// extracted by mini-css-extract-plugin
export default {"inputsContainer":"styles_inputsContainer__CEyzw","margin":"styles_margin__zgmOH"};